import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  FieldSelectYesNo,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterialGroup } from 'shared-pages';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { name: likeObj },
          { ekaCodeValues: likeObj },
          { unClassValues: likeObj },
          { notes: likeObj },
        ],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (
      values.useInProduction !== undefined &&
      values.useInProduction !== null &&
      values.useInProduction !== ''
    ) {
      where = { ...where, useInProduction: values.useInProduction };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  //console.log("filters-init ", initialValues);

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    useInProduction: initialValues?.useInProduction ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Απόβλητο, ΕΚΑ, UN, Παρατηρήσεις )')}
          type="search"
        />
        <FieldSelectYesNo as={FormCol} name="useInProduction" label="Είναι παραγόμενο" />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} />
      </Row>
    </FormFilterCard>
  );
};
